<template>
  <div class="container body-container" ref="container">
    <app-video :canPlay="canPlayVideo"></app-video>    
    <div class="container home-container">
      <p>{{ title }}</p>
      <div class="scanner-container">
        <transition name="flip" mode="out-in">
          <keep-alive>
            <app-qrcode-stream v-if="scannerComponent === 'app-qrcode-stream'" @decode="decodeQrCode"></app-qrcode-stream>
            <app-order-input v-else-if="scannerComponent === 'app-order-input'"></app-order-input>
            <app-qrcode-scanner v-else></app-qrcode-scanner>
          </keep-alive>
        </transition>
        <div class="buttons">
          <app-home-button
            @button-clicked="enableScan"
            :isBusy="isScanning"
            label="Scan"
            fwIcon="qrcode"></app-home-button>
          <app-home-button
            @button-clicked="enableInput"
            :isBusy="isTyping"
            label="Write"
            fwIcon="pen"></app-home-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '../components/shared/Banner.vue'
import HomeButton from '../components/buttons/HomeButton.vue'
import OrderInput from '../components/scan/OrderInput.vue'
import QrcodeScanner from '../components/scan/QrCodeScanner.vue'
import Video from '../components/shared/Video.vue'

import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  name: 'Home',
  data () {
    return {
      title: 'Please scan your ticket QR Code to view your order',
      bannerImage: '/src/assets/images/order-scan-cut.png',
      bannerVideo: '/src/assets/video/buzzer_mobile_video.mp4',
      actionButtonText: 'Scan QR Code',
      isScanning: false,
      isTyping: false,
      wrongQrCode: false,
      scannerComponent: 'app-qrcode-scanner',
      canPlayVideo: false
    }
  },
  methods: {
    enableScan () {
      this.scannerComponent = this.isScanning ? 'app-qrcode-scanner' : 'app-qrcode-stream'
      this.isScanning = !this.isScanning
      if (this.isScanning) this.isTyping = false
      this.title = 'Please scan your ticket QR Code to view your order'
    },
    enableInput () {
      this.scannerComponent = this.scannerComponent !== 'app-order-input' ? 'app-order-input' : 'app-qrcode-scanner'
      this.isTyping = !this.isTyping
      if (this.isTyping) {
        this.title = 'Please enter your order number here'
        this.isScanning = false
      } else {
        this.title = 'Please scan your ticket QR Code to view your order'
      }
    },
    decodeQrCode (decodedString) {
      try {
        this.isScanning = false
        let qrCodeValue = decodedString.substring(decodedString.lastIndexOf('/') + 1)
        if (isNaN(qrCodeValue) || qrCodeValue == null || qrCodeValue == undefined) {
          this.wrongQrCode = true
          setTimeout(() => {
            this.wrongQrCode = false
          }, 1000)
        } else {
          this.$router.push('/order/' + qrCodeValue)
        }
      } catch (error) {
        this.wrongQrCode = true
        setTimeout(() => {
          this.wrongQrCode = false
        }, 1000)
      }
    }
  },
  mounted () {
    this.$refs.container.style.width = screen.width + 'px'
  },
  components: {
    appBanner: Banner,
    appHomeButton: HomeButton,
    appOrderInput: OrderInput,
    appQrcodeScanner: QrcodeScanner,
    appVideo: Video,
    appQrcodeStream: QrcodeStream
  },
  created () {
    // this.$store.commit('reset')
    // this.$store.dispatch('getToken')
    setInterval(() => {
      this.canPlayVideo = !this.canPlayVideo
    }, 7500)
  }
}
</script>

<style scoped lang="scss">
  .home-container {
    overflow: none;
  }

  .scanner-container {
    width: 50%;
    height: 55%;
    max-width: 375px;
    margin: 10px;
    justify-content: space-around;
    -webkit-justify-content: space-around;
  }

  p {
    width: 87%;
    text-align: center;
    letter-spacing: .5px;
    font-size: 20px;
    font-weight: 500;
    margin: 10px 0;
    color: #464A53;
  }

  .buttons {
    position: absolute;
    left: 0 ; right: 0; bottom: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    -webkit-display: flex;
    -webkit-flex-direction: row;
    -webkit-justify-content: space-around;
    -webkit-align-items: center;
  }

  .flip-enter-active {
    animation: appear .1s linear forwards;
    -webkit-animation: appear .1s linear forwards;
  }

  .flip-leave-active {
    animation: disappear .1s linear forwards;
    -webkit-animation: disappear .1s linear forwards;
  }

  // iPhone 5 / SE
  @media screen and (max-width: 320px) {
    p {
      font-size: 18px;
    }
  }

  @keyframes appear {
    from {
      opacity: 0;
      transform: scale(0);
      -webkit-transform: scale(0);
    }
    to {
      opacity: 1;
      transform: scale(1);
      -webkit-transform: scale(1);
    }
  }

  @keyframes disappear {
    from {
      opacity: 1;
      transform: scale(1);
      -webkit-transform: scale(1);
    }
    to {
      opacity: 0;
      transform: scale(0);
      -webkit-transform: scale(0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue